export default __webpack_public_path__ + "static/media/banner-home.72381ef7.png";